import React from "react";
import { ReactComponent as LogoSVG } from "../../assets/svgs/CHUSA.svg";

export default function Logo() {
  return (
    <LogoSVG className="w-[15rem] h-[5rem] pb-6 " />
  );
}